import React from "react";
import { useParams } from "react-router-dom";
import AdminAssetCategoryPage from "./AdminAssetCategoryPage";

const AdminDynamicAssetCategory = () => {
  const { categoryName } = useParams();

  // Normalize the category name for title and database query mapping
  // e.g., "infrastructure" -> "Infrastructure"
  const title = categoryName
    ? categoryName
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "";

  // The AdminAssetCategoryPage handles mapping to the correct component (Building, Landscaping, or Other)
  return <AdminAssetCategoryPage category={title} title={title} />;
};

export default AdminDynamicAssetCategory;
